import { FC, PropsWithChildren } from 'react';
import { clsx } from 'clsx';

import styles from './CarouselWrapper.css';

interface ICarouselWrapperProps {
  className?: string;
}

export const CarouselWrapper: FC<PropsWithChildren<ICarouselWrapperProps>> = ({ children, className }) => {
  return <div className={clsx(styles['carousel'], className)}>{children}</div>;
};
